import { Suspense, lazy, useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import { useAuthStore } from './store/auth'

// 懒加载（148 懒加载刀——首屏只背核心 chunk，页面级按需拉取；
// 定量实证：单 bundle 822KB 走 tailnet=刷新慢；懒加载后首屏降至核心+当前页）
const Login = lazy(() => import('./pages/Login'))
const ProjectSelect = lazy(() => import('./pages/ProjectSelect'))
const Dashboard = lazy(() => import('./pages/Dashboard'))
const Assets = lazy(() => import('./pages/Assets'))
const Alerts = lazy(() => import('./pages/Alerts'))
const Tickets = lazy(() => import('./pages/Tickets'))
const TicketDetail = lazy(() => import('./pages/TicketDetail'))
const Notifications = lazy(() => import('./pages/Notifications'))
const Settings = lazy(() => import('./pages/Settings'))
const AIWorkbench = lazy(() => import('./pages/AIWorkbench'))
const Duty = lazy(() => import('./pages/Duty'))
const Leave = lazy(() => import('./pages/Leave'))
const Matrix = lazy(() => import('./pages/Matrix'))
const Org = lazy(() => import('./pages/Org'))
const OpsHealth = lazy(() => import('./pages/Ops'))
const Charges = lazy(() => import('./pages/Charges'))
const Mechanisms = lazy(() => import('./pages/Mechanisms'))
const System = lazy(() => import('./pages/System'))
const Releases = lazy(() => import('./pages/Releases'))
const Git = lazy(() => import('./pages/Git'))
const Evo = lazy(() => import('./pages/Evo'))
const SmokePage = lazy(() => import('./pages/OpsPlaceholder').then((m) => ({ default: m.SmokePage })))
const MetricsPage = lazy(() => import('./pages/Metrics'))
const Pitfalls = lazy(() => import('./pages/Pitfalls'))
const Backup = lazy(() => import('./pages/Backup'))
const A10 = lazy(() => import('./pages/A10'))
const AIOpsPage = lazy(() => import('./pages/OpsPlaceholder').then((m) => ({ default: m.AIOpsPage })))

const Boot = (
  <div className="p-16 text-center text-sm text-gray-400">加载中…</div>
)

function App() {
  const accessToken = useAuthStore((s) => s.accessToken)
  const projectId = useAuthStore((s) => s.projectId)
  useEffect(() => {
    let last = ''
    const fire = () => {
      const p = window.location.pathname
      if (p === last || p === '/login') return
      last = p
      void fetch('/api/v1/ops/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ domain: 'web', kind: 'page_visit', payload: { page: p } }),
      }).catch(() => {})
    }
    fire()
    window.addEventListener('popstate', fire)
    const t = window.setInterval(fire, 30_000)
    return () => {
      window.removeEventListener('popstate', fire)
      window.clearInterval(t)
    }
  }, [])

  if (accessToken && !projectId) {
    return (
      <Suspense fallback={Boot}>
        <Routes>
          <Route path="/select-project" element={<ProjectSelect />} />
          <Route path="*" element={<Navigate to="/select-project" replace />} />
        </Routes>
      </Suspense>
    )
  }

  return (
    <Suspense fallback={Boot}>
      <Routes>
        <Route path="/login" element={accessToken ? <Navigate to="/" replace /> : <Login />} />
        <Route
          path="/select-project"
          element={accessToken ? <ProjectSelect /> : <Navigate to="/login" replace />}
        />
        <Route
          path="/*"
          element={
            accessToken ? (
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/assets" element={<Assets />} />
                  <Route path="/tickets" element={<Tickets />} />
                  <Route path="/tickets/:id" element={<TicketDetail />} />
                  <Route path="/monitor" element={<Alerts />} />
                  <Route path="/ai" element={<AIWorkbench />} />
                  <Route path="/duty" element={<Duty />} />
                  <Route path="/leave" element={<Leave />} />
                  <Route path="/permissions" element={<Matrix />} />
                  <Route path="/org" element={<Org />} />
                  <Route path="/ops" element={<OpsHealth />} />
                  <Route path="/ops/charges" element={<Charges />} />
                  <Route path="/ops/mechanisms" element={<Mechanisms />} />
                  <Route path="/ops/smoke" element={<SmokePage />} />
                  <Route path="/ops/metrics" element={<MetricsPage />} />
                  <Route path="/ops/pitfalls" element={<Pitfalls />} />
                  <Route path="/ops/release" element={<Releases />} />
                  <Route path="/ops/git" element={<Git />} />
                  <Route path="/ops/evo" element={<Evo />} />
                  <Route path="/ops/backup" element={<Backup />} />
                  <Route path="/ops/a10" element={<A10 />} />
                  <Route path="/ops/ai" element={<AIOpsPage />} />
                  <Route path="/ops/system" element={<System />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Suspense>
  )
}

export default App
